import React from "react";
import { Row } from "antd";
import { useSelector } from "react-redux";
import "./style.css";

const LocalLoading = (props) => {
  const { isGlobalLoadingVisible } = useSelector((state) => state.globalReducer);
  return (
    <>
      {!isGlobalLoadingVisible && <>
        <Row className="row-loader" justify="center" align="middle">
          <div className="local-loading"></div>
        </Row>
        <h4>{props.text}</h4>
      </>}
    </>
  );
};

export default LocalLoading;